import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgXmarkSvgrepoCom = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "800px",
	height: "800px",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 6L18 18M18 6L6 18",
		stroke: "#000000",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgXmarkSvgrepoCom;
